import React, { useState, useEffect, useContext } from 'react'
import { Box } from '@mui/system'
import Sidebar from './sidebar'
import { TextField, Select, MenuItem, InputLabel, FormControl } from '@mui/material'

import Stepper from '@mui/material/Stepper';
import Step from '@mui/material/Step';
import StepButton from '@mui/material/StepButton';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import { makeStyles } from '@mui/material/styles';

import "../App.css"

import { addDoc, collection, query, getDocs } from "firebase/firestore";
import { db, storage } from "../firebase.js";


import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
//import FormControl from '@mui/material/FormControl';
import FormLabel from '@mui/material/FormLabel';
import { uploadBytes, ref, getDownloadURL } from 'firebase/storage';

import DeleteIcon from '@mui/icons-material/Delete';

import { DropzoneAreaBase } from 'material-ui-dropzone';
import { async } from '@firebase/util';

import DataContext from "../context/context";
import getDropDownData from './hook/getDropDownData';


const steps = ['General Information', 'Contract Details', 'Emergency Contact', "Training", "Correspondence", "Files"];

let trainingTypeOLD = ["CSCS", "Streetworks", "CPC Driver Qualification", "Tacho Driver", "CPCS Number", "SWQR Number", "CITB Test ID", "CITB Number", "NPORS Number", "SHEA Telecommunications", "IPAF 3a and 3b", "NPORS  Telescopic Handler ex 360 slew", "NPORS Forward Tipping Dumper Wheeld All Sizes Excluding Mini/Skip", "NPORS Rear Tipping Dumper (Srticulated/Wheeled/Above and Below 10 Tonne)", "Npors Excavator 180  below 5 ton", "NPORS Skidsteer Loader (Wheeled)", "NPORS Excavator below 10 tonne  tracked", "NPORS 360 Excavator Above and Below 10 Tonne Tracked", "NPORS  Slinger/Signaller", "NPORS Road Roller", "CPCS Forward Tipping Dumper - Wheeled", "CPCS Forward Tipping Dumper - Tracked", "CPCS Ride on Roller", "CPCS Appointed Person", "CPCS 180 Below 5 Tonne", "CPCS 180 Above 5 Tonne", "CPCS 360 Below 10 Tonne - Tracked", "CPCS 360 Above 10 Tonne - Tracked", "CPCS 360 Below 10 Tonne - Wheeled", "CPCS 360 Above 10 Tonne - Wheeled", "CPCS 360 Below 10 Tonne - Tracked - Lifting Operations", "CPCS 360 Above 10 Tonne - Tracked - Lifting Operations", "SSP - Health and Safety Awareness", "SSP - SSSTS", "SSP - SMSTS", "SSP - SEATS", "SSP - Directors Role in Health and Safety", "Carmel 180 Excavator All Sizes Wheeled", "Carmel Ride on Roller", "Carmel Forward Tipping Dumper Wheeled", "Carmel Confined Space Entry", "Carmel 360 Below 10 Tonne Tracked", "Carmel/npors Quick Hitch", "Carmel Skid Steer - Wheeled", "MGL Quick Hitch", "Oil Spill Responder", "Pipeline and Plant Training Specialist - Telehandler", "Face Fit", "Confined Spaces (Level Unknown)", "City and Guilds Confined Space - Medium Risk", "Vehicle Banksman", "Fire Warden", "IOSH Managers", "Scaffold Inspection", "PASMA Tower", "EPF  Edge protection"]
let trainingType = ['Volunteer Code of Conduct', 'Lone Working Policy and Procedure', 'Conflict Resolution', 'Food Handling, Safety & Hygiene', 'First Aid', 'Fire Safety', 'Safeguarding', 'Health & Safety', 'Data Protection', 'Drugs & Alcohol', 'Naloxone', 'Bereavement and Trauma'];

let qualificationType = ["Level 2 NVQ Diploma in Construction Operations and Civil Engineering Services", "Level 2 NVQ in Plant Operations - Slinger Signaller/Loader Securer", "Level 6 NVQ Diploma in Construction Contracting Operations Management", "Level 2 NVQ Diploma in Land Drilling Lead Driller", "City and Guilds Number", "Manual Handling", "Cat and Genny", "Asbestos Awareness", "Abrasive Wheels", "SWQR Operator", "Emergency First Aid at Work", "First Aid at Work", "Bricklaying"]
trainingType = trainingType.sort((a, b) => a.localeCompare(b));
qualificationType = qualificationType.sort((a, b) => a.localeCompare(b));


export default function AddNew() {
  const [rows, setRows] = useState([])

  const [dropDownData, setdropDownData] = useState();

  let dropdata = useContext(DataContext);

  let arr = [];

  useEffect(() => {
    test()

    async function test() {
      arr = []
      getDataName()
    }

    setRows(arr)
    setdropDownData(dropdata);
    if (!dropdata) {
      setdropDownData(getDropDownData());
    }


  }, [])

  async function getDataName() {
    let arr = []
    const q = query(collection(db, "staff"));
    const querySnapshot = await getDocs(q);
    querySnapshot.forEach((doc) => {
      let obj = doc.data();
      Object.assign(obj, { doc: doc.id });
      console.log(obj)
      arr.push(obj)
    });

    setRows(arr)

  }



  const [firstName, setfirstName] = useState("")
  const [surName, setsurName] = useState('')
  const [jobTitle, setjobTitle] = useState('')
  const [email, setemail] = useState('')
  const [address1, setaddress1] = useState('')
  const [address2, setaddress2] = useState('')
  const [contact, setcontact] = useState('')
  const [DOB, setDOB] = useState('')
  const [postCode, setpostCode] = useState('')
  const [drivingLicence, setdrivingLicence] = useState("")
  const [town, settown] = useState('')
  const [nationalIns, setnationalIns] = useState('')
  const [startDate, setstartDate] = useState('')
  const [rateOfPay, setrateOfPay] = useState('')
  const [periodOfPay, setperiodOfPay] = useState('')
  const [probaition, setprobaition] = useState('')
  const [contarctSigned, setcontarctSigned] = useState('')
  const [nextOfKinName, setnextOfKinName] = useState('')
  const [nextOfKinNumber, setnextOfKinNumber] = useState('')
  const [nextOfKineRelationship, setnextOfKineRelationship] = useState('')
  const [volunteer, setvolunteer] = useState('')
  const [url, seturl] = useState([])
  const [gender, setgender] = useState('')
  const [concDate, setconcDate] = useState("")
  const [concType, setconcType] = useState("")
  const [concLog, setconcLog] = useState("")
  const [concComment, setconcComment] = useState("")
  const [conc, setconc] = useState([])
  const [training, settraining] = useState([])


  const [activeStep, setActiveStep] = React.useState(0);
  const [completed, setCompleted] = React.useState({});

  const pushData = async () => {
    settraining(inputList)

    console.log(inputList)
    let main = {

      id: Date.now(),
      firstName,
      surName,
      jobTitle,
      email,
      address1,
      address2,
      contact,
      DOB,
      postCode,
      drivingLicence,
      town,
      nationalIns,
      startDate,
      rateOfPay,
      periodOfPay,
      probaition,
      contarctSigned,
      nextOfKinName,
      nextOfKinNumber,
      nextOfKineRelationship,
      training: inputList,
      volunteer,
      files: url,
      gender,
      conc,

    }
    console.log(main)
    await addDoc(collection(db, "staff"), main)
    handleComplete()
  }

  const resetState = () => {

    setfirstName()
    setsurName()
    setjobTitle()
    setemail()
    setaddress1()
    setaddress2()
    setcontact()
    setDOB()
    setpostCode()
    setdrivingLicence()
    settown()
    setnationalIns()
    setstartDate()
    setrateOfPay()
    setperiodOfPay()
    setprobaition()
    setcontarctSigned()
    setnextOfKinName()
    setnextOfKinNumber()
    setnextOfKineRelationship()
    setInputList([{ training: "", date: "" }])
    settraining()
    setvolunteer()
    seturl()
    setgender()
    setconc([])
    setconcComment()
    setconcDate()
    setconcLog()
    setconcType()


  }

  const totalSteps = () => {
    return steps.length;
  };

  const completedSteps = () => {
    return Object.keys(completed).length;
  };

  const isLastStep = () => {
    return activeStep === totalSteps() - 1;
  };

  const allStepsCompleted = () => {
    return completedSteps() === totalSteps();
  };

  const handleNext = () => {
    const newActiveStep =
      isLastStep() && !allStepsCompleted()
        ? // It's the last step, but not all steps have been completed,
        // find the first step that has been completed
        steps.findIndex((step, i) => !(i in completed))
        : activeStep + 1;
    setActiveStep(newActiveStep);
  };

  const handleBack = () => {
    setActiveStep((prevActiveStep) => prevActiveStep - 1);
  };

  const handleStep = (step) => () => {
    setActiveStep(step);
  };

  const handleComplete = () => {
    const newCompleted = completed;
    newCompleted[activeStep] = true;
    setCompleted(newCompleted);
    handleNext();
  };

  const handleCompleteSPC = () => {
    let obj = {
      concDate,
      concType,
      concLog,
      concComment,
      id: Date.now() * Math.random()
    }
    if (concLog != "" & concComment != "") {
      setconc(oldArray => [...oldArray, obj])
    }


    const newCompleted = completed;
    newCompleted[activeStep] = true;
    setCompleted(newCompleted);
    handleNext();
  };

  const handleReset = () => {
    setActiveStep(0);
    setCompleted({});
    resetState()
  };

  const [inputList, setInputList] = React.useState([{ training: "", date: "" }]);
  const [inputList1, setInputList1] = React.useState([{ qualification: "", date: "" }]);

  // handle input change
  const handleInputChange = (e, index) => {
    const { name, value } = e.target;
    const list = [...inputList];
    list[index][name] = value;
    setInputList(list);
  };
  const handleInputChange1 = (e, index) => {
    const { name, value } = e.target;
    const list = [...inputList1];
    list[index][name] = value;
    setInputList1(list);
  };

  // handle click event of the Remove button
  const handleRemoveClick = index => {
    const list = [...inputList];
    list.splice(index, 1);
    setInputList(list);
  };
  const handleRemoveClick1 = index => {
    const list = [...inputList1];
    list.splice(index, 1);
    setInputList1(list);
  };

  // handle click event of the Add button
  const handleAddClick = () => {
    setInputList([...inputList, { training: "", date: "" }]);
  };
  const handleAddClick1 = () => {
    setInputList1([...inputList1, { qualification: "", date: "" }]);
  };
  let urlArr = []

  return (


    <Box sx={{ display: 'flex', justifyContent: "center",marginTop: "20px", }}>
      <Sidebar />
      <Box sx={{ width: '60%' }}>
        <Stepper activeStep={activeStep} alternativeLabel sx={{
          '& .Mui-active': {
            color: "#1c3261",
          },
        }}>
          {steps.map((label, index) => (
            <Step key={label} completed={completed[index]}>
              <StepButton color="inherit" onClick={handleStep(index)}>
                {label}
              </StepButton>
            </Step>
          ))}
        </Stepper>
        <div>
          {allStepsCompleted() ? (
            <React.Fragment>
              <div className='LoginPage2'>
                <Typography sx={{ mt: 2, mb: 1 }}>
                  Employee Added Sucessfully!!
                </Typography>
                <Box sx={{ display: 'flex', flexDirection: 'row', pt: 2 }}>
                  <Box sx={{ flex: '1 1 auto' }} />
                  <Button onClick={handleReset} style={{ color: "#1c3261" }}>Add New</Button>
                </Box>
              </div>
            </React.Fragment>
          ) : (
            <React.Fragment>
              {/* ADDING FORM */}

              {
                activeStep == 0
                  ? <div className="LoginPage">
                    <TextField className="addform" id="outlined-basic" label="First Name" variant="outlined" style={{ width: "45%" }} onChange={(e) => setfirstName(e.target.value)} value={firstName} />
                    <TextField type="text" className='addform' id="outlined-basic" label="Surname" variant="outlined" style={{ width: "45%" }} onChange={(e) => setsurName(e.target.value)} value={surName} />
                    <FormControl style={{ width: "45%" }}>
                      <InputLabel id="demo-simple-select-label">Gender</InputLabel>
                      <Select
                        value={gender}
                        onChange={(e) => setgender(e.target.value)}
                        labelId="demo-simple-select-label"
                        id="demo-simple-select"
                        label="Location"
                      >
                        <MenuItem value={"male"}>Male</MenuItem>
                        <MenuItem value={"female"}>Female</MenuItem>
                        <MenuItem value={"null"}></MenuItem>
                      </Select>
                    </FormControl>
                    <TextField type="text" className='addform' id="outlined-basic" label="Job Title" variant="outlined" style={{ width: "45%" }} onChange={(e) => setjobTitle(e.target.value)} value={jobTitle} />
                    <TextField type="email" className='addform' id="outlined-basic" label="Email" variant="outlined" style={{ width: "45%" }} onChange={(e) => setemail(e.target.value)} value={email} />
                    <TextField type="text" className='addform' id="outlined-basic" label="Address 1" variant="outlined" style={{ width: "45%" }} onChange={(e) => setaddress1(e.target.value)} value={address1} />
                    <TextField type="number" className='addform' id="outlined-basic" label="Contact" variant="outlined" style={{ width: "45%" }} onChange={(e) => setcontact(e.target.value)} value={contact} />
                    <TextField type="text" className='addform' id="outlined-basic" label="Address 2" variant="outlined" style={{ width: "45%" }} onChange={(e) => setaddress2(e.target.value)} value={address2} />
                    <TextField type="date" label="Date of Birth" InputLabelProps={{ shrink: true, }} className='addform' style={{ width: "45%" }} id="outlined-basic" variant="outlined" onChange={(e) => setDOB(e.target.value)} value={DOB} />
                    <TextField type="text" className='addform' id="outlined-basic" label="Town/County" variant="outlined" style={{ width: "45%" }} onChange={(e) => settown(e.target.value)} value={town} />

                    <TextField type="text" className='addform' id="outlined-basic" label="Post Code" variant="outlined" style={{ width: "45%" }} onChange={(e) => setpostCode(e.target.value)} value={postCode} />
                    <TextField type="text" className='addform' id="outlined-basic" label="Driving License" variant="outlined" style={{ width: "45%" }} onChange={(e) => setdrivingLicence(e.target.value)} value={drivingLicence} />


                    <Button disabled={activeStep === 0} onClick={handleBack} className='addform' variant="outlined" style={{ marginTop: "30px", width: "49%", color: "#1c3261" }}>{completedSteps() === totalSteps() - 1
                      ? 'Back'
                      : 'Back'}</Button>
                    <Button onClick={handleComplete} className='addform' variant="contained" style={{ width: "49%", height: "50px", marginTop: "30px", backgroundColor: "#1c3261" }}>{completedSteps() === totalSteps() - 1
                      ? 'Finish'
                      : 'Next'}</Button>

                  </div>
                  : activeStep == 1 ?
                    <div className="LoginPage">
                      <TextField type="text" className='addform' id="outlined-basic" label="National Insurance Number" variant="outlined" style={{ width: "45%" }} onChange={(e) => setnationalIns(e.target.value)} value={nationalIns} />
                      <TextField type="date" label="Start Date" InputLabelProps={{ shrink: true, }} className='addform' style={{ width: "45%" }} id="outlined-basic" variant="outlined" onChange={(e) => setstartDate(e.target.value)} value={startDate} />
                      <TextField type="number" className='addform' id="outlined-basic" label="Rate of Pay £" variant="outlined" style={{ width: "45%" }} onChange={(e) => setrateOfPay(e.target.value)} value={rateOfPay} />
                      <FormControl style={{ width: "45%" }}>
                        <InputLabel id="demo-simple-select-label">Period of Pay</InputLabel>
                        <Select
                          onChange={(e) => setperiodOfPay(e.target.value)} value={periodOfPay}
                          labelId="demo-simple-select-label"
                          id="demo-simple-select"
                          label="periodOfpay"
                        >
                           {dropDownData
                                ? dropDownData.staffPeriodOfPay.map((val) => (
                                    <MenuItem value={val}>{val}</MenuItem>
                                  ))
                                : null}
                        </Select>
                      </FormControl>
                      <FormControl>
                        <FormLabel id="demo-radio-buttons-group-label">Contract Signed</FormLabel>
                        <RadioGroup
                          onChange={(e) => setcontarctSigned(e.target.value)} value={contarctSigned}
                          row
                          aria-labelledby="demo-radio-buttons-group-label"

                          name="radio-buttons-group"
                        >
                          <FormControlLabel value="yes" control={<Radio />} label="Yes" />
                          <FormControlLabel value="no" control={<Radio />} label="NO" />
                        </RadioGroup>
                      </FormControl>

                      <FormControl style={{ width: "45%" }}>
                        <InputLabel id="demo-simple-select-label">Probation Period</InputLabel>
                        <Select
                          onChange={(e) => setprobaition(e.target.value)} value={probaition}
                          labelId="demo-simple-select-label"
                          id="demo-simple-select"
                          label="probaition"
                        >
                          {dropDownData
                                ? dropDownData.StaffProbationPeriod.map((val) => (
                                    <MenuItem value={val}>{val}</MenuItem>
                                  ))
                                : null}

                        </Select>
                      </FormControl>
                      <FormControl style={{ width: "45%" }}>
                        <InputLabel id="demo-simple-select-label">Volunteer</InputLabel>
                        <Select
                          onChange={(e) => setvolunteer(e.target.value)} value={volunteer}
                          labelId="demo-simple-select-label"
                          id="demo-simple-select"
                          label="periodOfpay"
                        >
                          <MenuItem value={"yes"}>Yes</MenuItem>
                          <MenuItem value={"no"}>No</MenuItem>
                          <MenuItem value={"null"}></MenuItem>
                        </Select>
                      </FormControl>
                      <TextField type="text" className='addform' id="outlined-basic" label="Next of kin Relationship" variant="outlined" style={{ width: "45%", visibility: "hidden" }} />

                      <Button disabled={activeStep === 0} onClick={handleBack} className='addform' variant="outlined" style={{ width: "49%", color: "#1c3261", borderColor: "#1c3261", height: "50px", marginTop: "30px" }} >{completedSteps() === totalSteps() - 1
                        ? 'Back'
                        : 'Back'}</Button>
                      <Button onClick={handleComplete} className='addform' variant="contained" style={{ width: "49%", backgroundColor: "#1c3261", height: "50px", marginTop: "30px" }} >{completedSteps() === totalSteps() - 1
                        ? 'Finish'
                        : 'Next'}</Button>

                    </div>
                    : activeStep == 2 ?
                      <div className="LoginPage">
                        <TextField className="addform" id="outlined-basic" label="Next of Kin Name" variant="outlined" style={{ width: "45%" }} onChange={(e) => setnextOfKinName(e.target.value)} value={nextOfKinName} />
                        <TextField type="number" className='addform' id="outlined-basic" label="Next of Kin Number" variant="outlined" style={{ width: "45%" }} onChange={(e) => setnextOfKinNumber(e.target.value)} value={nextOfKinNumber} />
                        <TextField type="text" className='addform' id="outlined-basic" label="Next of Kin Relationship" variant="outlined" style={{ width: "45%" }} onChange={(e) => setnextOfKineRelationship(e.target.value)} value={nextOfKineRelationship} />
                        <TextField type="text" className='addform' id="outlined-basic" label="Next of kin Relationship" variant="outlined" style={{ width: "45%", visibility: "hidden" }} />

                        <Button disabled={activeStep === 0} onClick={handleBack} className='addform' variant="outlined" style={{ width: "40%", color: "#1c3261", borderColor: "#1c3261", height: "50px", marginTop: "30px" }}>{completedSteps() === totalSteps() - 1
                          ? 'Back'
                          : 'Back'}</Button>
                        <Button onClick={handleComplete} className='addform' variant="contained" style={{ width: "40%", backgroundColor: "#1c3261", height: "50px", marginTop: "30px" }}>{completedSteps() === totalSteps() - 1
                          ? 'Finish'
                          : 'Next'}</Button>

                      </div>

                      : activeStep == 3 ?
                        <div className="LoginPage">
                          {
                            inputList.map((x, i) => {
                              return (
                                <div style={{ width: "100%" }}>
                                  <FormControl style={{ width: "45%" }}>
                                    <InputLabel id="demo-simple-select-label">Training Type</InputLabel>
                                    <Select
                                      value={inputList[i].training}
                                      name="training"
                                      onChange={e => handleInputChange(e, i)}
                                      labelId="demo-simple-select-label"
                                      id="demo-simple-select"
                                      label="Location"
                                    >
                                       {dropDownData
                                ? dropDownData.staffTrainingType.map((val) => (
                                    <MenuItem value={val}>{val}</MenuItem>
                                  ))
                                : null}
                                    </Select>
                                  </FormControl>


                                  <TextField onChange={e => handleInputChange(e, i)} value={inputList[i].date} name="date" type="date" label="Expiry Date" InputLabelProps={{ shrink: true, }} className='addform' style={{ width: "45%", marginLeft: "10px" }} id="outlined-basic" variant="outlined" />
                                  {inputList.length !== 1 &&
                                    <Button onClick={() => handleRemoveClick(i)} className='addform' variant="contained" style={{ width: "5%", backgroundColor: "#FF6A74", marginLeft: "10px", height: "50px", color: "white ", borderColor: "red", }}><DeleteIcon sx={{ color: "white" }} /></Button>

                                  }

                                  <div className="btn-box">

                                    {inputList.length - 1 === i && <Button onClick={handleAddClick} className='addform' variant="outlined" style={{ width: "100%", height: "50px", marginTop: "30px", color: "#1c3261", borderColor: "#1c3261", }}>+ Add New</Button>}
                                  </div>
                                </div>

                              )
                            })
                          }



                          <Button disabled={activeStep === 0} onClick={handleBack} className='addform' variant="outlined" style={{ width: "49%", color: "#1c3261", borderColor: "#1c3261", height: "50px", marginTop: "30px" }}>{completedSteps() === totalSteps() - 1
                            ? 'Back'
                            : 'Back'}</Button>
                          <Button onClick={handleComplete} className='addform' variant="contained" style={{ width: "49%", backgroundColor: "#1c3261", height: "50px", marginTop: "30px" }}>{completedSteps() === totalSteps() - 1
                            ? 'Finish'
                            : 'Next'}</Button>
                        </div>


                        : activeStep == 4 ?
                          <div className='LoginPage'>
                            <TextField type="date" label="Date" InputLabelProps={{ shrink: true, }} className='addform' style={{ width: "45%" }} id="outlined-basic" variant="outlined" onChange={(e) => setconcDate(e.target.value)} value={concDate} />
                            <FormControl style={{ width: "45%" }}>
                              <InputLabel id="demo-simple-select-label">Type</InputLabel>
                              <Select
                                onChange={(e) => setconcType(e.target.value)} value={concType}
                                labelId="demo-simple-select-label"
                                id="demo-simple-select"
                                label="Type"
                              >
                                {dropDownData
                                ? dropDownData.staffCorrespondenceType.map((val) => (
                                    <MenuItem value={val}>{val}</MenuItem>
                                  ))
                                : null}
                              </Select>
                            </FormControl>
                            <FormControl style={{ width: "100%" }}>
                                  <InputLabel id="demo-simple-select-label">Logged By </InputLabel>
                                  <Select
                                    value={concLog}
                                    onChange={(e) => setconcLog(e.target.value)}
                                    labelId="demo-simple-select-label"
                                    id="demo-simple-select"
                                    label="Location"
                                  >
                                    {rows.map((v) => {
                                      return (
                                        <MenuItem value={v.firstName + " " + v.surName}>{v.firstName + " " + v.surName}</MenuItem>

                                      )
                                    })}
                                  </Select>
                                </FormControl>
                            <TextField
                              onChange={(e) => setconcComment(e.target.value)} value={concComment}
                              className="addform" style={{ width: "100%" }}
                              // id={ `tt_description_text outlined-multiline-static`}
                              label="Add a comment "
                              multiline
                              rows={5}
                            // onBlur={ (f)=>(this.textOnBlur({id:answeringPainSpot.spotId, value:f.target.value, doc_name:answeringPainSpot.doc_name})) }
                            />


                            <Button disabled={activeStep === 0} onClick={handleBack} className='addform' variant="outlined" style={{ width: "49%", color: "#1c3261", borderColor: "#1c3261", height: "50px", marginTop: "30px" }}>{completedSteps() === totalSteps() - 1
                              ? 'Back'
                              : 'Back'}</Button>
                            <Button onClick={handleCompleteSPC} className='addform' variant="contained" style={{ width: "49%", backgroundColor: "#1c3261", height: "50px", marginTop: "30px" }}>{completedSteps() === totalSteps() - 1
                              ? 'Finish'
                              : 'Next'}</Button>
                          </div>
                          : <div className="LoginPage">
                            <ul>
                              {
                                url.map((item) => {
                                  return (
                                    <li>{item.name}</li>
                                  )
                                })
                              }
                            </ul>

                            <DropzoneAreaBase
                              filesLimit="3"
                              maxFileSize={500000000000000}
                              onDrop={async (accept) => {
                                const file = accept[0];
                                console.log(file.path)

                                const blob = await fetch(URL.createObjectURL(file)).then((r) => r.blob())
                                const storageRef = ref(storage, `files/${file.lastModified}`);

                                await uploadBytes(storageRef, blob).then((snapshot) => {

                                  getDownloadURL(ref(storage, `files/${file.lastModified}`))
                                    .then((u) => {
                                      let obj = {
                                        path: file.lastModified,
                                        name: file.path,
                                        url: u
                                      }

                                      seturl(oldArray => [...oldArray, obj])
                                      console.log(url)

                                    })
                                    .catch((error) => {
                                      alert("try again later")
                                    });

                                });

                              }

                              }
                            />

                            <Button disabled={activeStep === 0} onClick={handleBack} className='addform' variant="outlined" style={{ width: "49%", color: "#1c3261", borderColor: "#1c3261", height: "50px", marginTop: "30px" }}>{completedSteps() === totalSteps() - 1
                              ? 'Back'
                              : 'Back'}</Button>
                            <Button onClick={pushData} className='addform' variant="contained" style={{ width: "49%", backgroundColor: "#1c3261", height: "50px", marginTop: "30px" }}>{completedSteps() === totalSteps() - 1
                              ? 'Finish'
                              : 'Next'}</Button>
                          </div>
              }


              <Box sx={{ display: 'flex', flexDirection: 'row', pt: 2 }}>
                {/* <Button
                    color="inherit"
                    disabled={activeStep === 0}
                    onClick={handleBack}
                    sx={{ mr: 1 }}
                  >
                    Back
                  </Button> */}
                <Box sx={{ flex: '1 1 auto' }} />
                {/* <Button onClick={handleNext} sx={{ mr: 1 }}>
                    Next
                  </Button>
                  {activeStep !== steps.length &&
                    (completed[activeStep] ? (
                      <Typography variant="caption" sx={{ display: 'inline-block' }}>
                        Step {activeStep + 1} already completed
                      </Typography>
                    ) : (
                      <Button onClick={handleComplete}>
                        {completedSteps() === totalSteps() - 1
                          ? 'Finish'
                          : 'Complete Step'}
                      </Button>
                    ))} */}
              </Box>
            </React.Fragment>
          )}
        </div>
      </Box>

    </Box>

  )
}
